module.exports = __webpack_public_path__ + "static/media/icon_partners.c222ab00.svg";